export default {
  path: 'temporary-regulations/crew-scheduling',
  name: 'TemporaryRegulationsCrewScheduling',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/CrewSchedulingIndex.vue')
}
